import serviceClient from '../../service-client/service-client';
import handleAsyncError from '../../../utils/handle-async-error';
import constants from '../constants';

const downloadExternalAssets = ({ data, onSuccess, onError, onFail }) =>
  new Promise(async (resolve, reject) => {
    const { STATUSES, ASYNC_JOB_POLLING_TIMEOUT } = constants;
    const client = serviceClient.get();

    const [response, error] = await handleAsyncError(client.downloadExternalAssets(data));

    if (error) {
      if (onError) {
        onError(error);
      }
      reject(error);
      return;
    }

    const { id } = response.data;

    const pollAsyncJob = async () => {
      const {
        data: { status, results },
      } = await client.getAsyncJob(id);

      switch (status) {
        case STATUSES.IN_PROGRESS: {
          setTimeout(pollAsyncJob, ASYNC_JOB_POLLING_TIMEOUT);
          break;
        }
        case STATUSES.COMPLETE: {
          const images = results.length ? results : [];
          if (onSuccess) {
            onSuccess(images);
          }
          resolve(images);
          break;
        }
        case STATUSES.FAILED: {
          if (onFail) {
            onFail(results.code === 'error');
          }
          resolve([]);
          break;
        }
        default:
      }
    };

    const [, err] = await handleAsyncError(pollAsyncJob());

    if (err) {
      if (onError) {
        onError(err);
      }
      reject(err);
    }
  });

export default downloadExternalAssets;
